import ViewRegisterSale from "../components/registerviews/register-sale/ViewRegisterSale"
import ViewBillList from "../components/tabledataviews/bill-list/ViewBillList"
import ViewStorageList from "../components/tabledataviews/storage-list/ViewStorageItemList"
import ViewPendingSale from "../components/tabledataviews/sale-pending/ViewPendingSale"
import ViewPosItemList from "../components/tabledataviews/pos-list/ViewPosItemList"
import ViewCashSessionList from "../components/tabledataviews/cash-session-list/ViewCashSessionList"
import ViewCashRegisterList from "../components/tabledataviews/cash-register-list/ViewCashRegisterList"
import ViewUserContactList from "../components/tabledataviews/contacts-list/ViewUserContactList"
import ViewBillDetail from "../components/tabledataviews/bill-list/ViewBillDetail"
import ViewCreditNoteList from "../components/tabledataviews/bill-list/ViewCreditNoteList"
import ViewDebitNoteList from "../components/tabledataviews/bill-list/ViewDebitNoteList"
import ViewCreateNote from "../components/registerviews/register-sale/ViewCreateNote"
import ViewSalesReports from "../components/tabledataviews/reports/ViewSalesReports"

export const modules = {
  PendingSalesList: "PENDING_SALES_LIST",
  RegisterSale: "REGISTER_SALE",
  StorageItemList: "STORAGE_ITEM_LIST",
  BillList: "BILL_LIST",
  POSList: "POS_LIST",
  CashSessionList: "CASH_SESSION_LIST",
  CashRegisterList: "CASH_REGISTER_LIST",
  ContactList: "CONTACT_LIST",
  BillDetail: "BILL_DETAIL",
  CreditNoteList: "CREDIT_NOTE_LIST",
  DebitNoteList: "DEBIT_NOTE_LIST",
  CreateNote: "CREATE_NOTE",
  SalesReports: "SALES_REPORTS",
} as const

export const app = {
  Storage: "STORAGE",
  Sales: "SALES"
} as const

export const contentPath = {
  [modules.RegisterSale]: "/register-sale",
  [modules.StorageItemList]: "/storage-item-list",
  [modules.BillList]: "/sale-support",
  [modules.PendingSalesList]: "/pending-sales",
  [modules.POSList]: "/pos-list",
  [modules.CashSessionList]: "/cash-session-list",
  [modules.CashRegisterList]: "/cash-register-list",
  [modules.ContactList]: "/contact-list",
  [modules.BillDetail]: "/bill-detail/:uid",
  [modules.CreditNoteList]: "/credit-notes",
  [modules.DebitNoteList]: "/debit-notes",
  [modules.CreateNote]: "/create-note/:uid",
  [modules.SalesReports]: "/sales-reports",
} as const

export const saleStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
} as const

export const contentLayout = {
  [modules.RegisterSale]: ViewRegisterSale,
  [modules.StorageItemList]: ViewStorageList,
  [modules.BillList]: ViewBillList,
  [modules.PendingSalesList]: ViewPendingSale,
  [modules.POSList]: ViewPosItemList,
  [modules.CashSessionList]: ViewCashSessionList,
  [modules.CashRegisterList]: ViewCashRegisterList,
  [modules.ContactList]: ViewUserContactList,
  [modules.BillDetail]: ViewBillDetail,
  [modules.CreditNoteList]: ViewCreditNoteList,
  [modules.DebitNoteList]: ViewDebitNoteList,
  [modules.CreateNote]: ViewCreateNote,
  [modules.SalesReports]: ViewSalesReports,
} as const

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY || "",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_PROJECT_ID || "",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_APP_ID || "",
  measurementId: process.env.REACT_APP_MEASUREMENT_ID || ""
}
export const baseURL = process.env.REACT_APP_MODULE_BASE_URL || ""
export const vapidKey = process.env.REACT_APP_VAPID_KEY || ""